(function ($, document, window) {
	'use strict';

	$(function () {
        const $carousel = $('.js-pricing-cards');

        $carousel.each(function() {
            const $carousel = $(this);
            const $nav = $carousel.parent().find('.js-pricing-cards-nav');
            const prevEl = $nav.find('.js-carousel-nav-prev').toArray();
            const nextEl = $nav.find('.js-carousel-nav-next').toArray();
            const isSm = $carousel.hasClass('js-pricing-cards-sm');

            const swiper = new Swiper(this, {
                direction: 'horizontal',
                slidesPerView: 1,
				spaceBetween: isSm ? 10 : 20,

                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                },

                breakpoints: {
                    1400: {
                        slidesPerView: 4,
                        spaceBetween: isSm ? 10 : 40,
                    },

                    1024: {
                        slidesPerView: isSm ? 2 : 4,
                    },

                    580: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                }
			});

            const handleCarouselVisibility = () => {
                const windowWidth = $(window).width();
                const totalSlides = $carousel.find('.js-pricing-card').length;

                if ((windowWidth >= 1024 && totalSlides <= (isSm ? 2 : 4)) || (windowWidth >= 580 && totalSlides <= 2)) {
                    $nav.hide();
                } else $nav.show();
            }

            handleCarouselVisibility();
            $(window).on('resize', handleCarouselVisibility);
		});
	});
})(jQuery, document, window);
